import React from "react";
import { Button, Table, DatePicker, SelectPicker, Alert, Progress, Notification, Input } from "rsuite";
import axios from "../../utilities/axios";
import _, { filter } from "lodash";
import TablePagination from "rsuite/lib/Table/TablePagination";
import dayjs from "dayjs";
import { CheckPicker } from 'rsuite';
import axiosReport from "../../utilities/axiosReport";

const { Column, HeaderCell, Cell } = Table;

export class ReportStock extends React.Component<any, {}> {

  public state: any = {
    dateIni: dayjs().subtract(30, 'days').format('MM/DD/YYYY'),
    endDate: dayjs().format('MM/DD/YYYY'),
    cnpj: "",
    selectedWorkshop: null,
    selectedtireMeasurements: null,
    loading: false,
    showFieldsReport: [
      "stock_created_at",
      "stock_mechanics_cnpj",
      "stock_mechanics_fk_user_id",
      "stock_fk_tire_measurement_id",
      "stock_count_amount",
    ],
    filterValues: {
      stock_created_at_init: {
        "field": "stock_created_at",
        "op": "gte",
        "value": dayjs().subtract(30, 'days').format('YYYY-MM-DD HH:mm:ss.sss')
      },
      stock_created_at_end: {
        "field": "stock_created_at",
        "op": "lte",
        "value": dayjs().format('YYYY-MM-DD HH:mm:ss.sss')
      },
      // stock_mechanics_cnpj: {
      //   "field": "stock_mechanics_cnpj",
      //   "op": "andWhere",
      //   "op": "",
      //   "value": ''
      // },
      stock_fk_tire_measurement_id: {
        "field": "stock_fk_tire_measurement_id",
        // "op": "andWhere",
        "op": "",
        "value": ''
      },
      stock_mechanics_fk_user_id: {
        "field": "stock_mechanics_fk_user_id",
        "op": "",
        "value": ''
      }
    },
  }

  componentDidUpdate(prevProps: any, prevState: any) {
    // if (prevState.cnpj !== this.state.cnpj) {
    //   this.state.filterValues['stock_mechanics_cnpj'].value = this.state.cnpj
    //   this.state.filterValues['stock_mechanics_cnpj'].op = "andWhere"
    // }
    // if (prevState.selectedtireMeasurements !== this.state.selectedtireMeasurements) {
    //   this.state.filterValues['stock_fk_tire_measurement_id'].value = this.state.selectedtireMeasurements
    //   this.state.filterValues['stock_fk_tire_measurement_id'].op = "andWhere"
    // }
    if (prevState.selectedWorkshop !== this.state.selectedWorkshop) {
      this.state.filterValues['stock_mechanics_fk_user_id'].value = this.state.selectedWorkshop
      this.state.filterValues['stock_mechanics_fk_user_id'].op = "andWhere"
    }
  }

  public locale = {
    sunday: "DON",
    monday: "SEG",
    tuesday: "TER",
    wednesday: "QUA",
    thursday: "QUI",
    friday: "SEX",
    saturday: "SAB",
    ok: "Ok",
    today: "Hoje",
    yesterday: "Ontem",
    hours: "Horas",
    minutes: "Minutos",
    seconds: "Segundos",
  };

  handleReport = async () => {
    this.setState({ loading: true })
    await axiosReport
      .post(`/api/v1/reports/generate`, { params: Object.values(this.state.filterValues), crud: "stocks", type: "report", showFieldsReport: this.state.showFieldsReport })
      .then((res) => {
        setTimeout(() => {
          window.open(`${window.location.protocol}//` + window.location.host.split('25565').join("25567") + res.data.outputUrl)
        }, 13000);
      })
      .catch((e) => {
        Notification.error({
          title: 'Erro!',
          description: e.response.data.message
        })
        this.setState({ loading: false });
      })
      .finally(() => {
        // this.setState({ loading: false })
        setTimeout(() => { this.setState({ loading: false }) }, 13000)
      })
  }

  onChange = (alias: any, field: any, op: any, value: any) => {
    this.setState({ filterValues: { ...this.state.filterValues, [alias]: { field: field, op: op, value: value } } })
  };

  render() {
    const { tireMeasurements, workshops, selectedWorkshop, selectedtireMeasurements } = this.props
    return (
      <>
        <div style={{ display: 'flex', flexDirection: "column", flexWrap: 'wrap', width: '100%' }}>
          <div style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap' }}>
            <div style={{ display: 'flex', flexDirection: 'column', width: '24%', marginBottom: 16, marginRight: "1%" }}>
              <div>Data Inicial</div>
              <DatePicker
                defaultValue={this.state.dateIni}
                style={{ width: '100%' }}
                locale={this.locale}
                format="DD/MM/YYYY"
                onChange={(date: any) => this.onChange("stock_created_at_init", "stock_created_at", "gte", dayjs(date).format('YYYY-MM-DD HH:mm:ss.sss'))}
                placeholder="DD/MM/AAAA"
              />
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', width: '24%', marginBottom: 16, marginRight: "1%" }}>
              <div>Data Final</div>
              <DatePicker
                defaultValue={this.state.endDate}
                style={{ width: '100%' }}
                locale={this.locale}
                format="DD/MM/YYYY"
                onChange={(date: any) => this.onChange("stock_created_at_end", "stock_created_at", "lte", dayjs(date).format('YYYY-MM-DD 23:59:59.999'))}
                placeholder="DD/MM/AAAA"
              />
            </div>
            {/* <div style={{ display: 'flex', flexDirection: 'column', width: '25%', marginBottom: 16 }}>
              <div>CNPJ da Oficína</div>
              <Input
                value={this.state.cnpj}
                onChange={(event: any) => {
                  this.setState({ cnpj: event })
                }}
              />
            </div> */}
            <div style={{ display: 'flex', flexDirection: 'column', width: '50%', marginBottom: 16 }}>
              <div>Nome da Oficina</div>
              <CheckPicker
                data={workshops}
                placeholder={"Selecione..."}
                // value={selectedWorkshop}
                // onChange={(event) => {
                //   this.setState({ selectedWorkshop: event })
                // }}
                onChange={(event) => {
                  this.onChange("stock_mechanics_fk_user_id", "stock_mechanics_fk_user_id", "inlist", event)
                }}
              />
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', width: '100%', marginBottom: 16 }}>
              <div>Medida do Pneu</div>
              <CheckPicker
                value={selectedtireMeasurements}
                data={tireMeasurements}
                placeholder={"Selecione..."}
                onChange={(event) => {
                  this.onChange("stock_fk_tire_measurement_id", "stock_fk_tire_measurement_id", "inlist", event)
                  // this.setState({ selectedtireMeasurements: event })
                }}
              />
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', width: '16%', marginTop: 16 }}>
              <Button
                color="green"
                onClick={this.handleReport}
                loading={this.state.loading}
              >Gerar Relatório</Button>
            </div>
          </div>
        </div>
      </>
    )
  }
}